import { styled } from "@mui/material";
import { FC } from "react";
import { LoginBox, LoginFormData } from "../organisms/login-box";
import { LoginWallpaper } from "../atoms/login-wallpaper";

export type LoginTemplateProps = {
  onSubmit: (data: LoginFormData) => void;
  loading: boolean;
};

export const LoginTemplate: FC<LoginTemplateProps> = ({
  onSubmit,
  loading,
}) => {
  return (
    <Container>
      <div className="login-box">
        <LoginBox loading={loading} onSubmit={onSubmit} />
      </div>
      <div className="login-cover">
        <LoginWallpaper />
      </div>
    </Container>
  );
};

const Container = styled("div")(({ theme }) => ({
  backgroundColor: "#e0e0e0",
  display: "flex",
  flexDirection: "row",
  minHeight: "100vh",
  position: "relative",
  ".login-box": {
    backgroundColor: "#fff",
    width: "100%",
    zIndex: 1,
  },
  ".login-cover": {
    display: "none",
    flex: 1,
  },
  [theme.breakpoints.up("sm")]: {
    ".login-box": {
      maxWidth: 500,
      boxShadow: "0 0 40px #00000040",
    },
    ".login-cover": {
      display: "block",
    },
  },
}));
